import { CButton } from '@coreui/react-pro'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { getDiagnosisByCodes, getVisitDiagnosis, submitDiagCodes } from 'src/helper/backendHelper'
import { getPCCConditions } from 'src/helper/pccApiHelper'
import Loader from 'src/components/common/Loader/Loader'

PullFromFacility.propTypes = {
  setSelectedDiagnosis: PropTypes.any.isRequired,
  patientId: PropTypes.string,
  visitId: PropTypes.string,
}

export default function PullFromFacility({
  patientId,
  visitId,
  setSelectedDiagnosis,
  dos,
  isLast = false,
}) {
  const settings = useSelector((state) => state.user?.settings)
  const pccDosValue = Boolean(settings.pccDosFilter) ? dos : null

  const [isLoading, setLoading] = useState(false)

  const pullDiagnosis = async () => {
    setLoading(true)
    const results = await getPCCConditions(patientId, pccDosValue)
    if (results && results.length > 0) {
      let selected = results
        .filter((c) => c.clinicalStatus === 'ACTIVE')
        .map((c) => c.icd10.replaceAll('.', ''))

      if (!isLast) {
        // save to visit, and fetch from visit to get 'standardized' dx data
        await submitDiagCodes(visitId, { diagnosis_codes: selected })
        const diagnosisList = await getVisitDiagnosis(visitId)
        if (diagnosisList?.results) {
          setSelectedDiagnosis(diagnosisList?.results)
        }
      } else {
        // convert PCC DX to 'standard' DX data, since isLast, cant use visit
        const dx = await getDiagnosisByCodes(selected)
        setSelectedDiagnosis(dx?.results || [])
      }
    }
    setLoading(false)
  }

  return (
    <div>
      {isLoading && <Loader />}
      <CButton color="primary" onClick={() => pullDiagnosis()}>
        Pull from Facility
      </CButton>
    </div>
  )
}
